<template>
  <div
      class="custom-select"
      ref="dropdown"
      :class="{ 'error-border': isInvalid, 'valid-border': isValid }"
  >
    <div class="selected-option" @click="toggleDropdown">
      {{ selectedOption ? selectedOption.name : placeholder }}
    </div>
    <transition name="fade">
      <div
          class="dropdown"
          v-if="isOpen"
          :style="{ 'max-height': dropdownHeight }"

      >
        <div
            class="option"
            v-for="option in options"
            :key="option.value"
            @click="selectOption(option)"
        >
          {{ option.name }}
        </div>
      </div>
    </transition>
  </div>
</template>


<script setup>
import { ref, defineProps, defineEmits, computed, watch, onMounted, onBeforeUnmount } from 'vue';

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  placeholder: {
    type: String,
    default: 'Select an option',
  },
  dropdownHeight: {
    type: String,
    default: '216px',
  },
  required: {
    type: Boolean,
    default: false,
  }
});

const emit = defineEmits(['update:modelValue', 'change'])

const isOpen = ref(false)
const selectedOption = ref(null)
const dropdown = ref(null)

const isInvalid = computed(() => props.required && !selectedOption.value)
const isValid = computed(() => props.required && selectedOption.value)

const toggleDropdown = () => {
  isOpen.value = !isOpen.value
}

const selectOption = (option) => {
  selectedOption.value = option
  emit('update:modelValue', option)
  emit('change', option)
  isOpen.value = false
}

const handleClickOutside = (event) => {
  if (dropdown.value && !dropdown.value.contains(event.target)) {
    isOpen.value = false
  }
}

watch(() => props.options, () => {
  selectedOption.value = null
})

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>


<style scoped>
.custom-select {
  border: 2px solid rgba(255, 255, 255, 0.00);
  position: relative;
  padding: 10px;
  cursor: pointer;
  font-size: 12px;
  border-radius: 25px;
  color: #ffffff;
  background-color: rgba(37, 37, 37, 0.75);
  width: 100%;
}

.selected-option {
  white-space: nowrap;
  overflow: hidden;
}

.dropdown {
  position: absolute;
  top: 105%;
  left: 0;
  right: 0;
  background-color: rgba(37, 37, 37, 0.89);
  height: auto;

  overflow-y: auto;
  border-radius: 25px;
  z-index: 10;
  border: 1px solid black;
}

/* CSS классы для анимации с эффектом затухания (fade) */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

/* Пример комбинированного эффекта затухания и сдвига */
/*
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
.fade-enter-to,
.fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}
*/

.option {
  padding: 10px;
  text-align: start;
}

.error-border {
  border: 2px solid red !important;
}
.valid-border {
  border: 2px solid #5FF900 !important;
}
</style>

